<template>
   <el-form ref="formValidate" :model="params" inline label-width="100px" :rules="rules">
    <el-form-item prop="parentId" :label="$t('area.parentArea')" v-show="!isUpdate">
      <el-input v-model="parent.name" style="width:200px;" disabled></el-input>
    </el-form-item>
    <el-form-item prop="name" :label="$t('area.areaName')">
        <el-input type="text" v-model="params.name" :placeholder="$t('common.nameRequire')" style="width:200px;"> </el-input>
    </el-form-item>
    <el-form-item prop="status" :label="$t('area.areaStatus')">
      <zk-dictionary-select type="status" v-model="params.status" style="width:200px;"
      :placeholder="$t('common.statusRequire')"></zk-dictionary-select>
    </el-form-item>
    <el-form-item prop="value" :label="$t('common.remark')">
        <el-input type="text" v-model="params.remark" :placeholder="$t('common.remarkRequire')" style="width:200px;"> </el-input>
    </el-form-item>
  </el-form>
</template>
<script>
import * as areaService from '../../../services/area.js'
export default {
  name: 'zk-area-save-or-update',
  props: ['form', 'isUpdate'],
  data () {
    let checkStatus = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('common.statusRequire')))
      } else {
        callback()
      }
    }
    let rules = {
      name: [{ required: true, message: this.$t('common.nameRequire'), trigger: 'blur' }],
      status: [{ required: true, validator: checkStatus, trigger: 'blur' }]
    }
    return {
      params: {},
      parent: {},
      rules
    }
  },
  methods: {
    save () {
      return new Promise((resolve, reject) => {
        this.$refs.formValidate.validate(valid => {
          if (valid) {
            if (this.isUpdate) {
              resolve(areaService.update(this.params))
            } else {
              resolve(areaService.add(this.params))
            }
          } else {
            reject(valid)
          }
        })
      })
    },
    resetFields () {
      this.$refs.formValidate.resetFields()
      // this.params = JSON.parse(JSON.stringify(this.form))
    }
  },
  watch: {
    form (newValue) {
      if (newValue && this.isUpdate) {
        this.params = JSON.parse(JSON.stringify(this.form))
      } else {
        this.parent = JSON.parse(JSON.stringify(this.form))
        this.params = {
          parentId: this.parent.id
        }
      }
    },
    isUpdate (newValue) {
      if (newValue) {
        this.params = JSON.parse(JSON.stringify(this.form))
      } else {
        this.parent = JSON.parse(JSON.stringify(this.form))
        this.params = {
          parentId: this.parent.id
        }
      }
    }
  },
  mounted () {
    if (this.isUpdate) {
      this.params = JSON.parse(JSON.stringify(this.form))
    } else {
      this.parent = JSON.parse(JSON.stringify(this.form))
      this.params = {
        parentId: this.parent.id
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/cdpBase/baseComponents/areaSaveOrUpdate/src/main.vue